import ClockIcon from "../../../../../../../../../assets/svg/clock-icon";
import TimePicker from "../../../../../../../../../components/TimePicker/TimePicker";
import { FormikProps } from "formik";
import { AgentDetailsValues } from "../../../../utils/types";
import { EditUserDetailsValues } from "../../../../../EditUserDrawer/utils/types";

interface ShiftSchedulerProps {
  formik: FormikProps<AgentDetailsValues> | FormikProps<EditUserDetailsValues>;
}

export const ShiftScheduler = ({ formik }: ShiftSchedulerProps) => {
  // const weekdays = formik?.values?.weekdays;

  // const handleDayToggle = (day: string) => {
  //   const currentWeekdays = weekdays;
  //   const updatedWeekdays = currentWeekdays?.includes(day)
  //     ? currentWeekdays.filter((d: string) => d !== day)
  //     : [...currentWeekdays, day];
  //   formik?.setFieldValue("weekdays", updatedWeekdays);
  // };

  // const handleDeselectAll = () => {
  //   formik?.setFieldValue("weekdays", []);
  // };

  // const handleSelectAll = () => {
  //   formik?.setFieldValue("weekdays", daysOfWeek);
  // };

  // const isAllSelected = useMemo(
  //   () => weekdays?.length === daysOfWeek?.length,
  //   [weekdays]
  // );

  return (
    <div className=" mb-2.5">
      <div className="flex flex-col gap-y-3.5">
        <div className="flex items-start gap-x-1.5">
          <TimePicker
            value={formik?.values?.start_shift}
            label="Start time"
            placeholder="Select Time"
            onChange={(time: string) =>
              formik?.setFieldValue("start_shift", time)
            }
            onBlur={() => formik?.setFieldTouched("start_shift", true)}
            showChevron={false}
            Icon={ClockIcon}
            labelClassName="text-xs text-verba-field-label dark:text-verba-field-label-dk mb-1.5"
            iconClassName="w-3 h-3 text-gray-placeholder dark:text-gray-placeholder-dk"
            triggerIconClassName="bg-pure-white dark:bg-pure-white-dk border border-border-gray dark:border-border-gray-dk"
            selectedOptionContainerClassName="!py-2.5"
            optionClassName="text-md font-normal text-heading-text dark:text-heading-text-dk border-none"
            error={
              formik?.touched?.start_shift && !!formik?.errors?.start_shift
            }
            errorMessage={formik?.errors?.start_shift}
            errorClassName="text-xxs mt-1"
          />
          <TimePicker
            value={formik?.values?.end_shift}
            label="End time"
            placeholder="Select Time"
            onChange={(time: string) =>
              formik?.setFieldValue("end_shift", time)
            }
            onBlur={() => formik?.setFieldTouched("end_shift", true)}
            showChevron={false}
            Icon={ClockIcon}
            labelClassName="text-xs text-verba-field-label dark:text-verba-field-label-dk mb-1.5"
            iconClassName="w-3 h-3 text-gray-placeholder dark:text-gray-placeholder-dk"
            triggerIconClassName="bg-pure-white dark:bg-pure-white-dk border border-border-gray dark:border-border-gray-dk"
            selectedOptionContainerClassName="!py-2.5"
            optionClassName="text-md font-normal text-heading-text dark:text-heading-text-dk border-none"
            error={formik?.touched?.end_shift && !!formik?.errors?.end_shift}
            errorMessage={formik?.errors?.end_shift}
            errorClassName="text-xxs mt-1"
          />
        </div>
        {/* <div>
          <div className="text-xs text-verba-field-label dark:text-verba-field-label-dk mb-1.5">
            Days
          </div>
          <div className="flex gap-x-1 mb-2">
            {daysOfWeek?.map((day) => (
              <div key={day} className="flex flex-col items-center">
                <button
                  type="button"
                  onClick={() => handleDayToggle(day)}
                  className={`w-[50px] h-[50px] rounded-lg text-xs font-medium transition-all duration-200 ${
                    weekdays?.includes(day)
                      ? "bg-selected-option-highlight dark:bg-selected-option-highlight-dk border border-selected-option-highlight dark:border-selected-option-highlight-dk"
                      : "border border-border-gray dark:border-border-gray-dk"
                  }`}
                >
                  <div className="flex flex-col gap-y-2 items-center justify-center">
                    <span className="text-verba-indigo dark:text-verba-indigo-dk">
                      {day}
                    </span>
                    <input
                      type="checkbox"
                      checked={weekdays?.includes(day)}
                      className="w-3 h-3 rounded-sm cursor-pointer pointer-events-none"
                    />
                  </div>
                </button>
              </div>
            ))}
          </div>
          <div className="w-max cursor-pointer">
            {isAllSelected ? (
              <div
                className="flex items-center gap-1"
                onClick={handleDeselectAll}
              >
                <CrossIcon className="w-[14px] h-[14px] text-verba-red-alert dark:text-verba-red-alert-dk" />
                <span className="text-sm text-verba-red-alert dark:text-verba-red-alert-dk font-medium">
                  Deselect all
                </span>
              </div>
            ) : (
              <div
                className="flex items-center gap-1"
                onClick={handleSelectAll}
              >
                <CompletedIcon className="w-[14px] h-[14px] text-verba-blue dark:text-verba-blue-dk" />
                <span className="text-sm text-verba-blue dark:text-verba-blue-dk font-medium">
                  Select all
                </span>
              </div>
            )}
          </div>
        </div> */}
      </div>
    </div>
  );
};
